var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM8.59158 9.27209C8.45274 9.74829 8.16905 10 7.70427 10C7.06622 10 6.75055 9.4502 6.75055 8.87073C6.75055 8.12927 7.10669 7.63263 7.76463 7.21088C8.58554 6.66669 8.79681 6.37415 8.79681 5.78912C8.79681 5.2381 8.40446 4.85034 7.86121 4.85034C7.37831 4.85034 7.05237 5.10205 6.86523 5.59863C6.6902 6.04083 6.34613 6.26532 5.9236 6.26532C5.3562 6.26532 4.99403 5.87073 5.00008 5.25848C5.00008 4.966 5.06044 4.70068 5.18719 4.4422C5.59161 3.58502 6.59966 3 7.96985 3C9.79881 3 11 4.07483 11 5.72791C11 6.72791 10.5835 7.42175 9.6962 8C8.86925 8.53741 8.7123 8.78229 8.59158 9.27209ZM8.79993 11.9972C8.79993 12.5599 8.35019 13 7.79993 13C7.24437 13 6.79993 12.5599 6.79993 11.9972C6.79993 11.4401 7.24437 11 7.79993 11C8.35019 11 8.79993 11.4401 8.79993 11.9972Z",
    fill: "currentColor"
  })));
}

export default SvgQuestionCircle;